import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureGetRoleMapping, successGetRoleMapping } from "./RoleMappingList";
import { AddRoleScreen, failureAddRolesScreen, successAddRolesScreen } from "./AddRolesScreens";

/**
 * API call to fetch all screens
 */
const getRoleMappingApi = () => {
    return api.get("/api/screen/roles/screens/count");
};

/**
 * Saga to handle fetching screen list
 */
export function* getRoleMappingApiCall() {
    try {
        const response: AxiosResponse = yield call(getRoleMappingApi);
        yield put(successGetRoleMapping(response.data));
    } catch (error) {
        yield put(failureGetRoleMapping(error));
    }
}

const getAddRolesScreenApi = (action: PayloadAction<AddRoleScreen>) => {
    return api.post("/api/screen/roles/screens", action.payload);
};

export function* getAddRolesScreenApiCall(action: PayloadAction<AddRoleScreen>) {
    try {
        const response: AxiosResponse = yield call(getAddRolesScreenApi, action);
        yield put(successAddRolesScreen(response.data));
    } catch (error) {
        yield put(failureAddRolesScreen(error));
    }
}
